<template>
  <div class="members">
    <el-tabs type="border-card" value="members">
      <el-tab-pane name="members">
        <template #label>
          Участники
          <span class="members-counter">
            {{ totalMemberCount }}
          </span>
        </template>
        <evaluation-users-table
          :isDisabledSetting="evaluation && evaluation.status === 'finished'"
          ref="membersTable"
          @update-total-count="totalMemberCount = $event"
          @refresh-all="refreshAllTables"
        ></evaluation-users-table>
      </el-tab-pane>
      <el-tab-pane
        v-if="evaluation.status && evaluation.status !== 'finished'"
        name="errors"
      >
        <template #label>
          Ошибки
          <span
            class="members-counter"
            :class="{
              'members-counter-good':totalProfileErrorCount === 0,
              'members-counter-bad':totalProfileErrorCount !== 0,
            }"
          >
            {{ totalProfileErrorCount }}
          </span>
        </template>
        <evaluation-users-table
          :isDisabledSetting="evaluation.status && evaluation.status === 'finished'"
          ref="errorsTable"
          :isProfileError="true"
          :totalProfileErrorCount="totalProfileErrorCount"
          @update-total-count="totalProfileErrorCount = $event"
          @refresh-all="refreshAllTables"
        ></evaluation-users-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import EvaluationUsersTable from "@/modules/evaluation/components/evaluation/EvaluationUsersTable.vue";

export default {
  name: "evaluation-members",
  components: { EvaluationUsersTable },
  props: {
    evaluation: {
      type: Object,
      default: {}
    }
  },
  watch: {
    totalProfileErrorCount(val) {
      this.$emit('update-total-count', val);
    }
  },
  data() {
    return {
      totalMemberCount: 0,
      totalProfileErrorCount: 0,
    };
  },
  methods: {
    refreshAllTables() {
      this.$refs.membersTable?.loadEvaluationUsers();
      this.$refs.errorsTable?.loadEvaluationUsers();
      this.$emit("refresh-evaluators");
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/css/project-variables";

.members{

  .members-counter {
    margin-left: 10px;
    font-weight: bold;
    font-size: 1.1rem;

    &-good { color: $--color-success;}
    &-bad { color: $--color-danger;}
  }
}
</style>